import axios from "axios";

const base = "https://app.neoidea.com.br/sistema/index.php?r=outlet/services/";

const api = axios.create({
  baseURL: base,
});

api.interceptors.response.use(response => {
    return response;
}, (error) => {
  throw new Error(error?.response?.data?.descricao);
});

function mountFormData(data){
  let bodyFormData = new FormData();

  const allDataKeys = Object.keys(data)

  allDataKeys.forEach(key => {
    if(Array.isArray(data[key])) {
      for (var i = 0; i < data[key].length; i++) {
        bodyFormData.append(`${key}[]`, data[key][i]);}
    }
    else bodyFormData.append(key, data[key])
  })

  return bodyFormData
}

export async function sendRemoveDataRequest({ mdi, nome, email, solicitacao, lang = "ptbr" }) {
  let url = 'removacaoDadosMessage&lang=' + lang;
  
  const body = mountFormData({ mdi, nome, email, solicitacao })
  
  const response = await api.post(`${url}`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data.retorno;
}